import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getCustomers } from "../../../../services/sales/customerService";
import withGlobalData from "../../common/withGlobalData";
class SearchCustomer extends Component {
  state = {
    reload: this.props.globalData.reload,
    customers: [],
  };

  componentDidMount() {
    this.getCustomers();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getCustomers();
      this.setState({ reload: globalData.reload });
    }
  }

  async getCustomers() {
    const response = await getCustomers();
    const { data } = response.data;
    this.setState({ customers: data.customers });
  }

  render() {
    const { customers } = this.state;
    const { onSelectCustomer } = this.props;
    return (
      <CustomDataTableSearch
        data={customers}
        onRefreshData={() => {
          this.getCustomers();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectCustomer(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectCustomer(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Customer ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Customer Group",
            field: "customerGroupName",
            body: null,
            sortable: true,
          },
          {
            header: "Customer Name",
            field: "customerName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.customerName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Phone Number",
            field: "contactPhone",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.contactPhone} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "City",
            field: "city",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.city} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchCustomer);
